import type { Variants } from 'framer-motion';

export const STAMP_ENTER_SECONDS = 0.2;
export const STAMP_STAGGER_STEP_SECONDS = STAMP_ENTER_SECONDS * 0.55;
export const STAMP_STAGGER_BASE_DELAY_SECONDS = 0.3;
export const STAMP_JUST_EARNED_EXTRA_DELAY_SECONDS = 0.3;

/**
 * Gap between consecutive stamps of a multi-stamp reveal (a buy-all earns several at once). Shorter
 * than the 0.6s flourish itself, so they overlap into a cascade rather than playing one at a time.
 */
export const JUST_STAMPED_CASCADE_STEP_SECONDS = 0.35;

export const STORE_STAMP_STAGGER_STEP_SECONDS = STAMP_ENTER_SECONDS * 0.3;

export const makeStampVariants = (staggerStepSeconds: number = STAMP_STAGGER_STEP_SECONDS): Variants => ({
  hidden: { scale: 0.6, opacity: 0 },
  visible: (staggerIndex: number) => ({
    scale: 1,
    opacity: 1,
    transition: {
      duration: STAMP_ENTER_SECONDS,
      ease: [0.34, 1.15, 0.64, 1],
      delay: STAMP_STAGGER_BASE_DELAY_SECONDS + staggerIndex * staggerStepSeconds,
    },
  }),
});

export const stampVariants: Variants = makeStampVariants();
